"use client";

import { Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { Icon } from "@/components/ui/icon";
import { howItWorks } from "@/lib/data/homepage";

/**
 * How It Works — Cinematic horizontal timeline with 6 phase cards
 * connected by a flowing line. Each card has icon, number, title, body.
 */
export function HowItWorks() {
  return (
    <section id="how-it-works" className="relative section-pad">
      <Container>
        <Reveal className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full glass eyebrow-tiny text-[var(--color-emerald)]">
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--color-emerald)]" />
            How It Works
          </span>
          <h2 className="mt-6">
            From Intelligence to Dominance
          </h2>
          <p className="mt-4 text-body leading-relaxed text-[rgb(var(--fg-muted))] max-w-2xl mx-auto">
            A six-phase methodology that transforms raw data into strategic advantage — autonomously, continuously, and at scale.
          </p>
        </Reveal>

        <div className="relative">
          {/* Horizontal connector line */}
          <div className="hidden lg:block absolute top-[2.5rem] left-0 right-0 h-px bg-gradient-to-r from-transparent via-[var(--color-emerald)] to-transparent opacity-30" />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4">
            {howItWorks.map((step, i) => {
              const accent = ["var(--color-cyan)", "var(--color-emerald)", "var(--color-purple)", "var(--color-amber)", "var(--color-crimson)", "var(--color-denim)"][i];
              return (
                <Reveal key={step.step} delay={i * 80}>
                  <div className="relative h-full">
                    {/* Step circle */}
                    <div
                      className="relative grid place-items-center h-20 w-20 rounded-full mx-auto mb-4 transition-transform hover:scale-110"
                      style={{
                        background: `linear-gradient(135deg, color-mix(in oklch, ${accent} 30%, transparent), color-mix(in oklch, ${accent} 8%, transparent))`,
                        boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 50%, transparent), 0 8px 24px -10px ${accent}`,
                      }}
                    >
                      <Icon name={step.icon} className="h-7 w-7" style={{ color: accent }} />
                      <div className="absolute -top-1 -right-1 grid place-items-center h-7 w-7 rounded-full text-[0.65rem] font-bold font-mono-num" style={{ background: accent, color: "white" }}>
                        {step.step}
                      </div>
                    </div>
                    <div className="text-center">
                      <h3 className="mb-2">{step.title}</h3>
                      <p className="text-caption leading-relaxed text-[rgb(var(--fg-muted))]">{step.desc}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </Container>
    </section>
  );
}
